module.exports = __webpack_public_path__ + "media/images/undraw_empty_state_cactus-1045e5d5c5d3427266573f7d72680ac5.svg";